export default {
      id: "ic-para-thumbup-usage",
      viewBox: "0 0 14 15",
      url: "../dist/images/" + "sprite.svg#ic-para-thumbup-usage",
      toString: function () {
        return this.url;
      }
    }